import { Routes } from '@angular/router';
import { environment } from '@environments/environment';

import { HomeComponent } from './home';
import { LoadingAppComponent } from './home/loading-app/loading-app.component';
import { ChangePasswordComponent } from './profile/change-password/change-password.component';
import { authGuard } from './_helpers';
import { Role } from './_models';

export const routes: Routes = [
    { path: '', component: HomeComponent, canActivate: [authGuard] },
    { path: 'account', loadChildren: () => import('./account/account.routes').then(m => m.ACCOUNT_ROUTES) },
    { path: 'profile/change-password', loadChildren: () => import('./profile/profile.routes').then(m => m.PROFILE_ROUTES), component: ChangePasswordComponent },
    { path: 'profile', loadChildren: () => import('./profile/profile.routes').then(m => m.PROFILE_ROUTES), canActivate: [authGuard] },
    { path: 'admin', loadChildren: () => import('./admin/admin.routes').then(m => m.ADMIN_ROUTES), canActivate: [authGuard], data: { roles: [Role.Admin] } },
    {
        path: 'dxpro',
        canActivate: [authGuard],
        component: LoadingAppComponent,
        data: {
            externalUrl: environment.dxproAppUrl,
            roles: [Role.Admin, Role.DxPro],
            logoImage: '../../assets/logos/WHITE-DXPRO-2.svg',
            hideNav: true
        }
    },
    {
        path: 'vennhealth',
        canActivate: [authGuard],
        component: LoadingAppComponent,
        data: {
            externalUrl: environment.vennhealthAppUrl,
            roles: [Role.Admin, Role.VennHealth],
            logoImage: '../../assets/logos/WHITE-VENNHEALTH.svg',
            hideNav: true
        }
    },
    {
        path: 'precise',
        canActivate: [authGuard],
        component: LoadingAppComponent,
        data: {
            externalUrl: environment.preciseAppUrl,
            roles: [Role.Admin, Role.PRECISE],
            logoImage: '../../assets/logos/WHITE-PRECISE.svg',
            hideNav: true
        }
    },
    {
        path: 'biomarkers',
        canActivate: [authGuard],
        component: LoadingAppComponent,
        data: {
            externalUrl: environment.biomarkersAppUrl,
            roles: [Role.Admin, Role.PRECISE_Biomarkers],
            logoImage: '../../assets/logos/WHITE-PRECISE.svg',
            hideNav: true
        }
    },
    // {
    //   path: 'legacyprecise',
    //   canActivate: [authGuard],
    //   component: LoadingAppComponent,
    //   data: {
    //     externalUrl: environment.legacyPreciseAppUrl,
    //     roles: [Role.Admin, Role.PRECISE],
    //     logoImage: '../../assets/logos/WHITE-PRECISE.svg'
    //   }
    // },
    {
        path: 'predict',
        canActivate: [authGuard],
        component: LoadingAppComponent,
        data: {
            externalUrl: environment.predictAppUrl,
            roles: [Role.Admin, Role.PREDICT],
            logoImage: '../../assets/logos/WHITE-PREDICT.svg',
            hideNav: true
        }
    },
    {
        path: 'countyfips',
        canActivate: [authGuard],
        component: LoadingAppComponent,
        data: {
            externalUrl: environment.countyFipsAppUrl,
            roles: [Role.Admin, Role.US_COUNTY_FIPS],
            hideNav: true
        }
    },
    {
        path: 'tcri',
        canActivate: [authGuard],
        component: LoadingAppComponent,
        data: {
            externalUrl: environment.tcriUrl,
            roles: [Role.Admin],
            logoImage: '',
            hideNav: true
        }
    },
    // otherwise redirect to home
    { path: '**', redirectTo: '' }
];
